import React from "react";
import { ModuleRouter } from "src/components/molecules";
import { ChangePasswordRoute } from "./change-password.routes";
import { Layout } from "src/components/layout/Layout";

export function ChangePasswordModule() {
  return (
    <>
      <Layout>
        {ChangePasswordRoute.subRoutes && (
          <ModuleRouter subRoutes={ChangePasswordRoute.subRoutes} path={ChangePasswordRoute.path} />
        )}
      </Layout>
    </>
  );
}
